class ActivitySaveController {

    constructor($stateParams, access) {
        this.$stateParams = $stateParams;
        this.access = access;
    }

    $onInit () {
        this.activeTab = this.$stateParams.tab || 'activity';
    }

    canShow () {
        return this.access.check('manager') && !!this.activity.id;
    }
}

ActivitySaveController.$inject = ['$stateParams', 'access'];

export default ActivitySaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/controllers/activity.save.controller.js